import z from 'zod';

import { VALIDATION_TYPE } from 'src/features/validationTypes/utils/types';
import { CURRENCY } from 'src/types';
import { validationMessagesMap } from 'src/utils/messages';

export type ValidationTypeFormSchemaValues = z.infer<typeof validationTypeFormSchema>;
export const validationTypeFormSchema = z
    .object({
        name: z.string().max(64).nonempty(),
        validator_account: z.string().nonempty(),
        type: z.enum(VALIDATION_TYPE),
        amount: z.int().min(0).optional(),
        currency: z.enum(CURRENCY).nullable().optional(),
        is_active: z.boolean().optional(),
        can_be_stacked: z.boolean().optional(),
        can_be_combined: z.boolean().optional(),
        pricing_plan_identity: z.string().nullish(),
    })
    .superRefine((data, ctx) => {
        const hasAmount = data.type !== VALIDATION_TYPE.GUEST && data.type !== VALIDATION_TYPE.PRICING_PLAN_CHANGE;
        if (hasAmount && !data.amount) {
            ctx.addIssue({
                path: ['amount'],
                message: validationMessagesMap.validationErrorRequired,
                code: 'custom',
            });
        }
        if (data.type === VALIDATION_TYPE.CHARGE && !data.currency) {
            ctx.addIssue({
                path: ['currency'],
                message: validationMessagesMap.validationErrorRequired,
                code: 'custom',
            });
        }
        if (data.type === VALIDATION_TYPE.PRICING_PLAN_CHANGE && !data.pricing_plan_identity) {
            ctx.addIssue({
                path: ['pricing_plan_identity'],
                message: validationMessagesMap.validationErrorRequired,
                code: 'custom',
            });
        }
    });
